import { useEffect } from 'react';

/**
 * Component to set the page title dynamically
 * @param {object} props 
 * @param {string} props.title - The page title to set
 * @param {string} props.suffix - Optional suffix to append after the title
 */
function PageTitle({ title, suffix = "Paper Plane" }) {
  useEffect(() => {
    // Set the document title
    const fullTitle = suffix ? `${title} | ${suffix}` : title;
    document.title = fullTitle;
    
    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = "Paper Plane";
    };
  }, [title, suffix]);
  
  // This component doesn't render anything
  return null;
}

export default PageTitle; 